module.exports = __webpack_public_path__ + "static/media/promo.897159ab.png";